import { createSlice } from '@reduxjs/toolkit';
import {getGendersAsync} from './Actions';

export interface GendersValues {
  value: string; 
  label: string; 
}

export interface GendersState {
  status: 'idle' | 'loading' | 'failed';
  list: Array<GendersValues>;
  errorMessage: string | undefined;
}

const initialState: GendersState = {
  status: 'idle',
  list: [],
  errorMessage: '',
};


export const gendersSlice = createSlice({
  name: 'genders',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGendersAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getGendersAsync.rejected, (state, action: any) => {
        state.status = 'failed';
        state.list = [];
        state.errorMessage = action.payload.errorMessage;
      })
      .addCase(getGendersAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.list = action.payload;
        state.errorMessage = ''
      })
  },
});

export default gendersSlice.reducer;
